import Icon from '../components/Icon.vue'

Icon.register({
  'flag-checkered': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M466.5 66.9C487.7 57.1 512 72.6 512 95.9V339C512 349.6 506.8 359.5 498.2 365.4 462.3 390 423.8 406.3 375.7 406.3 308.3 406.3 264 371.5 210.4 371.5 159.6 371.5 124.3 381.5 96 393.6V488C96 501.3 85.3 512 72 512H56C42.7 512 32 501.3 32 488V101.9C17.5 91.8 8 75 8 56 8 24.3 34.3-1.3 66.3 0 94.8 1.2 118.1 24 119.9 52.5 120.4 60.8 119.1 68.8 116.3 76 137 68.4 159.4 64 184.3 64 251.7 64 296 98.8 349.6 98.8 390.1 98.8 432.2 82.9 466.5 66.9zM96 134.6V205.1C125 194.4 147.2 187.3 169.6 184.2V112.6C146.1 114.8 129.2 122.4 96 134.6zM316.8 143.8C290.4 139.1 266.9 129.8 243.2 122.5V189.9C267.4 196.6 290.8 206.3 316.8 212.2V143.8zM169.6 184.2V254.3C202.4 251.3 223.5 253.6 243.2 258.1V189.9C218 182.9 196.6 180.5 169.6 184.2zM243.2 326.4C269.5 331.1 292.9 340.4 316.8 347.8V280.4C292.5 273.6 269.3 263.9 243.2 258V326.4zM96 342.1C119.6 333.7 143.8 328.3 169.6 325.5V254.3C143.5 256.6 122.2 262.3 96 271.6V342.1zM464 120.5C442.7 129.4 417.4 138.1 390.4 143V214.9C417.7 210.5 440.4 200.8 464 191V120.5zM464 330.5V260C441.8 274.2 415.2 282.6 390.4 286V357.6C415.5 355.2 438.9 346.5 464 330.5zM316.8 212.2V280.4C342.5 287.5 363.4 289.7 390.4 286V214.9C364.4 219.1 340.5 217.6 316.8 212.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/flag-checkered.js
// module id = aeAo
// module chunks = 144